<template>
  <table v-table-resizer class="table table-striped">
    <thead>
      <tr>
        <th class="fandom">Fandom</th>
        <th class="prompts">Requests</th>
      </tr>
    </thead>
    <tbody v-if="!updating && !processing && filtered.length">
      <tr v-for="fandom in filtered" :key="fandom.index">
        <td class="fandom" data-label="Fandom">
          <strong> {{ fandom.name }}</strong>
        </td>

        <td class="prompts">
          <button v-if="!aggregatedPrompts[fandom.index]" class="btn btn-primary"
            @click="getAggregatedPrompts(exchangeId, aggregatetag, fandom.name, fandom.index)">
            Show Requests
          </button>

          <div v-if="aggregatedPrompts[fandom.index] == 'loading'" class="loading"></div>

          <keep-alive>
            <aggregated-prompt-table :prompts="aggregatedPrompts[fandom.index]" :fandom="fandom.index" v-if="aggregatedPrompts[fandom.index] && aggregatedPrompts[fandom.index].length && aggregatedPrompts[fandom.index] != 'loading'
      ">
            </aggregated-prompt-table>
          </keep-alive>
        </td>
      </tr>
    </tbody>
  </table>
</template>


<script>
import AggregatedPromptTable from "../components/aggregatedPromptTable.vue";
import utils from "../components/utils.js";
import tableResizer from "../directives/tableResizer";
// third party
import { mapGetters } from "vuex";
import { find } from "lodash-es"

export default {
  name: "aggregatedFandomTable",
  directives: {
    tableResizer
  },
  components: {
    AggregatedPromptTable
  },
  props: {
    updating: {
      type: Boolean,
      default: true
    },
    aggregatetag: {
      type: String
    },
    processing: {
      type: Boolean,
      default: true
    },
    filtered: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters([
      "exchangeId",
      "isExchangeOpen",
      "bookmarks",
      "fandoms",
      "loaded",
      "options",
      "promptmarks",
      "aggregatedPrompts"
    ])
  },
  methods: {
    ...utils
  }
};
</script>